//添加事件总线
import {EventEmitter} from 'events';
export default new EventEmitter();